export default {"src":"/_next/static/media/icon-customize.ea8ff45c.gif","height":250,"width":250,"blurWidth":0,"blurHeight":0};